<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: `GiftCards`,
        }
      ]"/>

    <div class="card ml-15">
      <div class="card-body">

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Código</th>
                <th>Comercio</th>
                <th>Comprador</th>
                <th>Cantidad (USD)</th>
                <th>Cantidad (DOP)</th>
                <th>Recibe - Nombre</th>
                <th>Recibe - Cédula</th>
                <th>Recibe - Teléfono</th>
                <th>Nota</th>
                <th>Estado</th>
                <th>Fecha de uso</th>
                <th class="text-center">Opciones</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="x in giftcards" :key="x.id">
                <td>{{ x.Code }}</td>
                <td>{{ x.Company ? x.Company.Name : '' }}</td>
                <td>{{ x.User ? x.User.Name : '' }}</td>
                <td>{{ x.Amount }}</td>
                <td>{{ x.AmountDOP }}</td>
                <td>{{ x.ReceiverName }}</td>
                <td>{{ x.ReceiverReference }}</td>
                <td>{{ x.ReceiverPhone }}</td>
                <td>{{ x.Note }}</td>
                <td>{{ x.Status }}</td>
                <td>{{ x.UsedAt }}</td>
                <td class="text-center">
                  <a v-if="!x.UsedAt" href="#" @click.prevent="markAsUsed(x)" class="text-primary cursor" title="Marcar como usado"><i class="fa fa-check"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { UtilsService } from '../../services/UtilsService';

export default {
  name: 'GiftCards',
  components: { 
    BreadCrumbs,
    Loader 
  },
  data(){
    return {
      utilsService: new UtilsService(),
      loading: false,
      giftcards: []
    }
  },
  methods: {
    async markAsUsed(giftCard){
      try {
        const ok = await this.$helpers.confirm('Esto no se puede deshacer');
        if(!ok){
          return;
        }
        await this.utilsService.markGiftCardAsUsed(giftCard.Id);
        this.get();
      } catch (error) {
        this.$helpers.message('Error', error.message, 'error');
      }
    },
    async get(){
      this.loading = true;
      try {
        const company = this.$store.getters.isAdmin ? '' : this.$store.getters.getCompany;
        const res = await this.utilsService.getGiftCards(company);
        if(res.ok){
          this.giftcards = res.data;
        }else{
          this.$helpers.message('Error', res.message, 'error');
        }
      } catch (error) {
        this.$helpers.message('Error', error.message, 'error');
      }
      this.loading = false;
    },
  },
  beforeMount(){
    this.get();
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 500 !important;
}
.fa{
  font-size: 1.2rem;
}
</style>